export const navbar = {
  Search: 'Buscar',
  Home: 'Inicio',
  'Your Library': 'Tu biblioteca',
  'Collapse your library': 'Collapsar tu biblioteca',
  'Expand your library': 'Expandir tu biblioteca',
  'Expand library view': 'Expandir vista de la biblioteca',
  'Shrink library view': 'Reducir vista de la biblioteca',
  Language: 'Idioma',
  'Contact me': 'Contactame',
  'Source code': 'Código fuente',
  Profile: 'Perfil',
  Settings: 'Configuración',
  'Log out': 'Cerrar sesión',
  SearchPlaceholder: '¿Qué querés reproducir?',
  'Create a new Playlist': 'Crear una nueva Playlist',
  Playlists: 'Playlists',
  Artists: 'Artistas',
  Composers: 'Compositores',
  Albums: 'Álbumes',
  Works: 'Obras',
  Recordings: 'Grabaciones',
  'Playlist created': 'Playlist creada',
  COMPACT: 'Compacto',
  GRID: 'Grilla',
  LIST: 'Lista',
  'Log In': 'Iniciar sesión',
  'Close search': 'Cerrar búsqueda',
  LibrarySortDefault: 'Orden predeterminado',
  LibrarySortRelevance: 'Relevancia',
};
